export class Approval {
  /**
   * The first approval number.
   */
  approval1: number;

  /**
   * The second approval number.
   */
  approval2: number;

  /**
   * The third approval number.
   */
  approval3: number;

  /**
   * The first approval user.
   */
  approvalUser1: string;

  /**
   * The second approval user.
   */
  approvalUser2: string;

  /**
   * The third approval user.
   */
  approvalUser3: string;

  /**
   * The first rejection date.
   */
  dateRejected1: Date;

  /**
   * The second rejection date.
   */
  dateRejected2: Date;

  /**
   * The third rejection date.
   */
  dateRejected3: Date;

  /**
   * The first approval date.
   */
  dateApproved1: Date;

  /**
   * The second approval date.
   */
  dateApproved2: Date;

  /**
   * The third approval date.
   */
  dateApproved3: Date;

  /**
   * Constructor
   * @param data
   */
  constructor(data?: any) {
    if (data) {
      this.approval1 = data.approval1;
      this.approval2 = data.approval2;
      this.approval3 = data.approval3;
      this.approvalUser1 = data.approvalUser1;
      this.approvalUser2 = data.approvalUser2;
      this.approvalUser3 = data.approvalUser2;
      this.dateApproved1 = data.dateApproved1 ? new Date(data.dateApproved1) : null;
      this.dateApproved2 = data.dateApproved2 ? new Date(data.dateApproved2) : null;
      this.dateApproved3 = data.dateApproved3 ? new Date(data.dateApproved3) : null;
      this.dateRejected1 = data.dateRejected1 ? new Date(data.dateRejected1) : null;
      this.dateRejected2 = data.dateRejected2 ? new Date(data.dateRejected2) : null;
      this.dateRejected3 = data.dateRejected3 ? new Date(data.dateRejected3) : null;
    }
  }
}
